import { range as remedaRange } from '@core/utils/remeda';

export function groupLines(lines: string): Record<number, true> {
  return lines.split(',').reduce<Record<number, true>>((result, range) => {
    if (range.includes('~')) {
      const [start, end] = range.split('~').map((n) => Number(n));
      remedaRange(start || 0, (end || 0) + 1).forEach((n) => {
        result[n] = true;
      });
    } else {
      result[Number(range)] = true;
    }

    return result;
  }, {});
}
